import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const ReservationsIcon = ({ width = 20, height = 20, fill = '#52575C' }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5.834c-.92 0-1.667.746-1.667 1.667H5A2.5 2.5 0 0 0 2.5 5v11.666a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5V5.001A2.5 2.5 0 0 0 15 2.5h-.833c0-.92-.746-1.667-1.667-1.667h-5zm6.667 3.333c0 .92-.746 1.667-1.667 1.667h-5c-.92 0-1.667-.746-1.667-1.667H5a.833.833 0 0 0-.833.834v11.666a.833.833 0 0 0 .833.834h10a.833.833 0 0 0 .833-.834V5.001A.834.834 0 0 0 15 4.167h-.833zM7.5 3.335v.832h5V2.501h-5v.833z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.834 10c0-.46.373-.834.833-.834h6.667a.833.833 0 0 1 0 1.667H6.667a.833.833 0 0 1-.833-.834zM5.834 14.167c0-.46.373-.833.833-.833h6.667a.833.833 0 0 1 0 1.667H6.667a.833.833 0 0 1-.833-.834z"
      fill={fill}
    />
  </svg>
);
